/* This file is autogenerated, see readme.md for instructions */
import MobilePhoneLandscapeSvgIcon from '@bloomreach/banana-theme/icons/mobile-phone-landscape.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MobilePhoneLandscapeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MobilePhoneLandscapeSvgIcon />
    </Icon>
  );
});

MobilePhoneLandscapeIcon.displayName = 'MobilePhoneLandscapeIcon';

export default MobilePhoneLandscapeIcon;
